import { render, staticRenderFns } from "./reject-withdraw.modal.vue?vue&type=template&id=0ff6ca36&"
import script from "./reject-withdraw.modal.vue?vue&type=script&lang=js&"
export * from "./reject-withdraw.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports